// Lazy access to @seventide/content (versioned explanations, FR-12.2). The content bundle is only
// downloaded when someone opens an explanation, keeping the first page load small.
export type ContentModule = typeof import('@seventide/content');

let promise: Promise<ContentModule> | null = null;

export function loadContent(): Promise<ContentModule> {
  promise ??= import('@seventide/content');
  return promise;
}
